import(/* webpackMode: "eager" */ "/var/www/blcmusic/src/app/error.tsx");
